import { Button } from "@/components/ui/button";
import { Calendar, MessageCircle } from "lucide-react";
import claraPortrait from "@/assets/clara-portrait-final.png";

interface PillarCTAWithPhotoProps {
  title: string;
  message: string;
  openDialog: () => void;
}

const PillarCTAWithPhoto = ({ title, message, openDialog }: PillarCTAWithPhotoProps) => (
  <div className="rounded-2xl bg-primary/5 border border-primary/10 p-5 sm:p-8 flex flex-col sm:flex-row items-center gap-5 sm:gap-8">
    <img
      src={claraPortrait}
      alt="Clara Camille, nutricionista brasileira na Austrália"
      className="w-20 h-20 sm:w-24 sm:h-24 rounded-full object-cover object-top shadow-lg ring-2 ring-primary/20 flex-shrink-0"
      loading="lazy"
      width={96}
      height={96}
    />
    <div className="flex flex-col items-center sm:items-start gap-3 sm:gap-4">
      <div className="text-center sm:text-left space-y-1.5">
        <p className="text-sm text-primary font-typewriter font-semibold uppercase tracking-wider">
          {title}
        </p>
        <p className="text-base sm:text-lg text-foreground font-sans leading-relaxed">
          {message}
        </p>
      </div>
      <div className="flex flex-col sm:flex-row gap-2.5 sm:gap-3">
        <Button
          size="lg"
          variant="gradient"
          className="rounded-full text-sm px-5 py-4"
          style={{ background: 'var(--gradient-green)' }}
          onClick={openDialog}
        >
          <Calendar className="mr-2 h-4 w-4" />
          Agendar consulta
        </Button>
        <Button
          size="lg"
          variant="gradient-outline"
          className="rounded-full text-sm px-5 py-4"
          onMouseEnter={(e) => { e.currentTarget.style.background = 'var(--gradient-green)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = ''; }}
          onClick={() => window.open('https://wa.me/61423038977', '_blank')}
        >
          <MessageCircle className="mr-2 h-4 w-4" />
          Falar no WhatsApp
        </Button>
      </div>
    </div>
  </div>
);

export default PillarCTAWithPhoto;
